import styled from 'styled-components';

export const FuturaTarjetaWrapper = styled.div`

._3sTov _35oaN{

    margin: 10px;

}

.card{

    margin-top: 16px;
}

}


.contenedor{

    display: grid;
    justify-content: center;
    align-items: center;
    

}

.div-mensaje{

    margin-top: 20px;
}

.iconcedula{

    display:block;
    margin:auto;
}

.iconliquidacion{

    margin-bottom: 5px;
    display:block;
    margin:auto;
}

.iconprevision{

    margin-bottom: 5px;
    display:block;
    margin:auto;
}

.info-uno{

}

.info-dos{

    margin-top: 18px;

}

.info-tres{

    margin-top: 18px;

}

.info-cuatro{

    display: flex;
    justify-content: center;
}

.info-cinco{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 24px;
}


.mensaje{
    font-weight: bold;
}

.p-dos{

    font-weight: bold;
    text-align: center;
}

.p-tres{
    font-size: 17px;
    padding-bottom: 10px;
    font-weight: bold;
    text-align: center;
}

.p-coment{
    font-size: 14px;
    width: 355px;
    text-align: center;
}

.p-comisiones{

    margin-top: 14px;
    font-weight: bold;
}

.p-info{

    margin-top: 14px;
}

.p-mensaje{

    font-weight: bold; 
    text-align: center;

}

.plastic{

    display: flex;
    justify-content: center;
}

.req-div{

    margin-top: 19px;
}

.t-dorada img{
    width: 100%;
    height: auto;

}

@media (max-width: 426px){

   
    .req-div{

        margin-top: 16px;
    }

    .Card-Class{

        margin: 0px;
    
    }

    .card-class-dos{

        margin-top: 17px;
    }

    .card {
        margin-top: 6px;

    }

  
    .info-cuatro{

        margin-top: -18px;
        margin-left: -5px;

    }

    .info-cinco{
        margin-top: 28px;
    }

    .p-comisiones {
        margin-top: 10px;
        font-weight: bold;
        
    }

    .p-dale{
        position: relative;
        top: -40px;
        left: 18px;
        color: white;
    }

    .p-dorada{
        position: relative;
        top: -21px;
        left: 24px;
        color: white;

    }

    .p-dorada-dos{
        position: relative;
        top: -98px;
        left: 22px;
        color: white;
        font-weight: bold

    }

    .p-internacional{
        position: relative;
        top: -20px;
        left: 23px;
        color: white;

    }

    .p-internacional-dos {
        position: relative;
        top: -98px;
        left: 23px;
        color: white;
        font-weight: bold;
    }

    .t-dale{
        margin-top: 24px;
    }

    .t-dorada{
        margin-top: 24px;
    }

    .tarjetainternacional{
        width: 100%;
        height: auto;
        margin-bottom: -24px;
    }

    .tarjetadale{
        width: 100%;
        height: auto;
    }

    .t-dorada img{
        width: 99%;
        height: auto;
        margin-bottom: -22px;
    }


    }


@media (max-width: 376px){

    .Card-Class{

        margin: -36px;
        margin-top: -44px;
    
    }

    .card {
        margin: 48px 36px;

    }

    .info-cuatro{
        margin-left: -4px;

    }



    .plastic {
        display: flex;
        justify-content: center;

    }   

    .p-dale{
        position: relative;
        top: -40px;
        left: 18px;
        color: white;
    }

    .p-dorada {
        position: relative;
        top: -17px;
        left: 18px;
        color: white;
    }

    .p-dorada-dos{
        position: relative;
        top: -87px;
        left: 16px;
        color: white;
        font-weight: bold

    }

    .p-internacional{
        position: relative;
        top: -21px;
        left: 18px;
        color: white;

    }

    .p-internacional-dos {
        position: relative;
        top: -90px;
        left: 16px;
        color: white;
        font-weight: bold;
    }
    

    .tarjetadale{
        width: 100%;
        height: auto;

    }

    

    .tarjetainternacional{
        width: 100%;
        height: auto;
        margin-bottom: -21px;

    }

    .t-dale{
        margin-top: 15px;
    }

    .t-dorada{
        margin-top: 17px;
    }

    .t-dorada img{
        width: 99%;
        height: auto;
        margin-bottom: -22px;
    }

}


@media (max-width: 321px){

    .Card-Class{

        margin: -36px;
        margin-top: -54px;
    
    }

    .card{
        margin-top: 54px;
    }

    
    .div-comision {
        display: grid;
        grid-template-rows: auto;
        grid-row-gap: 1em;
      }

    .info-cuatro{
        margin-left: -8px;

    }

    .plastic {
        margin-left: 11px;
        margin-top: -7px;
    }

    .p-comisiones {
        margin-top: 9px;
        font-weight: bold;
    }

 
     .t-dorada{
        position: relative;
        display: inline-block;
        text-align: center;
    }

    .p-dale{
        position: relative;
        top: -36px;
        left: 18px;
        color: white;
    }

    .p-dorada{
        position: relative;
        top: -12px;
        left: -84px;
    }
    

    .p-dorada-dos{
        position: relative;
        top: -74px;
        left: -51px;
        color: white;
        font-weight: bold;

    }

    .p-internacional{
        position: relative;
        top: -16px;
        left: 18px;
        color: white;

    }

    .p-internacional-dos{
        position: relative;
        top: -75px;
        left: 16px;
        color: white;
        font-weight: bold;

    }

    .t-dale{
        margin-top: 15px;
    }

    .t-dorada img{
        width: 103%;
        height: auto;
        margin-bottom: -22px;
    }

    .tarjetainternacional{
        width: 100%;
        height: auto;
        margin-bottom: -22px;

    }
    

}

`;

export default FuturaTarjetaWrapper;
